/// <amd-dependency path='VSS/LoaderPlugins/Css!WorkItemArea' />

import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import * as SelectWorkItemView from "TestManagement/Scripts/TFS.TestManagement.SelectWorkItemView";
import * as Resources from "TestManagement/Scripts/Resources/TFS.Resources.TestManagement";
import * as TestsOM from "TestManagement/Scripts/TFS.TestManagement";
import * as Dialogs from "VSS/Controls/Dialogs";

export interface ICreateNewRBSDialogProps {
    onSuccess(requirementIds: number[]): void;
    areaPath: string;
}

// This is a proxy component to load the query selector dialog using LegacyComponent
class CreateNewRBSProxy extends React.Component<ICreateNewRBSDialogProps, {}> {
    public render(): React.ReactNode {
        return <div />;
    }

    public componentDidMount(): void {
        const windowWidth = $(window).width();
        const windowHeight = $(window).height();
        Dialogs.show(SelectWorkItemView.SelectWorkItemsDialog, {
            width: windowWidth >= 1024 ? $(window).width() * 0.8 : $(window).width(),
            isSingleSelect: false,
            height: windowHeight >= 768 ? $(window).height() * 0.8 : $(window).height(),
            attachResize: true,
            resizable: false,
            dynamicSize: true,
            widthPct: windowWidth >= 1024 ? 0.8 : 1,
            heightPct: windowHeight >= 768 ? 0.8 : 1,
            okText: Resources.CreateSuites,
            okCallback: (requirementIds: number[]) => {
                if (requirementIds && requirementIds.length > 0) {
                    this.props.onSuccess(requirementIds);
                }
            },
            title: Resources.CreateRequirementSuite.toLocaleUpperCase(),
            workItemCategories: [
                TestsOM.WorkItemCategories.Requirement,
                TestsOM.WorkItemCategories.Bug,
                TestsOM.WorkItemCategories.Feature,
                TestsOM.WorkItemCategories.Epic
            ],
            hideQueryType: false,
            persistenceId: SelectWorkItemView.PersistenceIds.ADD_REQUIREMENTS_ID,
            supportWorkItemOpen: true,
            areaPath: this.props.areaPath
        }).setInitialFocus();
    }
}

registerLWPComponent("create-rbs-dialog-proxy", CreateNewRBSProxy);
